import { FetchAllPrintersApi } from "./backend_helper";

const { default: axios } = require("axios");

// export const FetchCountryListdata = async () => {
//   try {
//     const countryData = await axios.get("https://restcountries.com/v3.1/all", )
//   console.log("thisisfnasdklfnaklsdfnklasdnvklansd", countryData)
//     const countryList =
//       // await Promise.all(
//       countryData.data.map((country) => ({
//         name: country.name.common,
//         code: country.cca2,
//       }));
//     const countryName = countryList.sort((a, b) => {
//       const nameA = a.name.toLowerCase();
//       const nameB = b.name.toLowerCase();
//       return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
//     });
//     return countryName;
//     // }
//   } catch (error) {
//     console.error("Error in fetching country", error.message)
//   }
// };


const fetchavailableCountries = async () => {
  try {
    const response = await FetchAllPrintersApi();      
      return response.data || [];
  } catch (error) {
    console.error('Error fetching available countries:', error.message);
    return [];
  }
};


// export const FetchCountryListdata = async () => {
//   try {
//     await fetchavailableCountries();
//     // Hardcoded country list (ISO Alpha-2 code and common name)
//     const countryData = [
//       { name: "Afghanistan", code: "AF" },
//       { name: "Albania", code: "AL" },
//       { name: "Algeria", code: "DZ" },
//       { name: "Andorra", code: "AD" },
//       { name: "Angola", code: "AO" },
//       { name: "Argentina", code: "AR" },
//       { name: "Armenia", code: "AM" },
//       { name: "Australia", code: "AU" },
//       { name: "Austria", code: "AT" },
//       { name: "Azerbaijan", code: "AZ" },
//       { name: "Bahamas", code: "BS" },
//       { name: "Bahrain", code: "BH" },
//       { name: "Bangladesh", code: "BD" },
//       { name: "Belarus", code: "BY" },
//       { name: "Belgium", code: "BE" },
//       { name: "Bhutan", code: "BT" },
//       { name: "Brazil", code: "BR" },
//       { name: "Canada", code: "CA" },
//       { name: "China", code: "CN" },
//       { name: "Denmark", code: "DK" },
//       { name: "Egypt", code: "EG" },
//       { name: "Finland", code: "FI" },
//       { name: "France", code: "FR" },
//       { name: "Germany", code: "DE" },
//       { name: "India", code: "IN" },
//       { name: "Indonesia", code: "ID" },
//       { name: "Iran", code: "IR" },
//       { name: "Iraq", code: "IQ" },
//       { name: "Ireland", code: "IE" },
//       { name: "Israel", code: "IL" },
//       { name: "Italy", code: "IT" },
//       { name: "Japan", code: "JP" },
//       { name: "Jordan", code: "JO" },
//       { name: "Kenya", code: "KE" },
//       { name: "Kuwait", code: "KW" },
//       { name: "Malaysia", code: "MY" },
//       { name: "Mexico", code: "MX" },
//       { name: "Nepal", code: "NP" },
//       { name: "Netherlands", code: "NL" },
//       { name: "New Zealand", code: "NZ" },
//       { name: "Nigeria", code: "NG" },
//       { name: "Norway", code: "NO" },
//       { name: "Oman", code: "OM" },
//       { name: "Pakistan", code: "PK" },
//       { name: "Philippines", code: "PH" },
//       { name: "Poland", code: "PL" },
//       { name: "Portugal", code: "PT" },
//       { name: "Qatar", code: "QA" },
//       { name: "Russia", code: "RU" },
//       { name: "Saudi Arabia", code: "SA" },
//       { name: "Singapore", code: "SG" },
//       { name: "South Africa", code: "ZA" },
//       { name: "South Korea", code: "KR" },
//       { name: "Spain", code: "ES" },
//       { name: "Sri Lanka", code: "LK" },
//       { name: "Sweden", code: "SE" },
//       { name: "Switzerland", code: "CH" },
//       { name: "Thailand", code: "TH" },
//       { name: "Turkey", code: "TR" },
//       { name: "UAE", code: "AE" },
//       { name: "Ukraine", code: "UA" },
//       { name: "United Kingdom", code: "GB" },
//       { name: "United States", code: "US" },
//       { name: "Vietnam", code: "VN" },
//       { name: "Yemen", code: "YE" },
//     ];

//     // Sort alphabetically
//     const countryName = countryData.sort((a, b) =>
//       a.name.toLowerCase().localeCompare(b.name.toLowerCase())
//     );

//     return countryName;
//   } catch (error) {
//     console.error("Error in fetching country", error.message);
//     return [];
//   }
// };

export const FetchCountryListdata = async () => {
  try {
    // API returns: ["India", "United States", ...]
    const availableCountryNames = await fetchavailableCountries();

    // Convert to Set for faster lookup
    const availableCountrySet = new Set(
      availableCountryNames.map(name => name.toLowerCase())
    );
    console.log("availableCountrySet",availableCountryNames);
    const countryData = [
      { name: "Afghanistan", code: "AF" },
      { name: "Albania", code: "AL" },
      { name: "Algeria", code: "DZ" },
      { name: "Andorra", code: "AD" },
      { name: "Angola", code: "AO" },
      { name: "Argentina", code: "AR" },
      { name: "Armenia", code: "AM" },
      { name: "Australia", code: "AU" },
      { name: "Austria", code: "AT" },
      { name: "Azerbaijan", code: "AZ" },
      { name: "Bahamas", code: "BS" },
      { name: "Bahrain", code: "BH" },
      { name: "Bangladesh", code: "BD" },
      { name: "Belarus", code: "BY" },
      { name: "Belgium", code: "BE" },
      { name: "Bhutan", code: "BT" },
      { name: "Brazil", code: "BR" },
      { name: "Canada", code: "CA" },
      { name: "China", code: "CN" },
      { name: "Denmark", code: "DK" },
      { name: "Egypt", code: "EG" },
      { name: "Finland", code: "FI" },
      { name: "France", code: "FR" },
      { name: "Germany", code: "DE" },
      { name: "India", code: "IN" },
      { name: "Indonesia", code: "ID" },
      { name: "Iran", code: "IR" },
      { name: "Iraq", code: "IQ" },
      { name: "Ireland", code: "IE" },
      { name: "Israel", code: "IL" },
      { name: "Italy", code: "IT" },
      { name: "Japan", code: "JP" },
      { name: "Jordan", code: "JO" },
      { name: "Kenya", code: "KE" },
      { name: "Kuwait", code: "KW" },
      { name: "Malaysia", code: "MY" },
      { name: "Mexico", code: "MX" },
      { name: "Nepal", code: "NP" },
      { name: "Netherlands", code: "NL" },
      { name: "New Zealand", code: "NZ" },
      { name: "Nigeria", code: "NG" },
      { name: "Norway", code: "NO" },
      { name: "Oman", code: "OM" },
      { name: "Pakistan", code: "PK" },
      { name: "Philippines", code: "PH" },
      { name: "Poland", code: "PL" },
      { name: "Portugal", code: "PT" },
      { name: "Qatar", code: "QA" },
      { name: "Russia", code: "RU" },
      { name: "Saudi Arabia", code: "SA" },
      { name: "Singapore", code: "SG" },
      { name: "South Africa", code: "ZA" },
      { name: "South Korea", code: "KR" },
      { name: "Spain", code: "ES" },
      { name: "Sri Lanka", code: "LK" },
      { name: "Sweden", code: "SE" },
      { name: "Switzerland", code: "CH" },
      { name: "Thailand", code: "TH" },
      { name: "Turkey", code: "TR" },
      { name: "UAE", code: "AE" },
      { name: "Ukraine", code: "UA" },
      { name: "United Kingdom", code: "GB" },
      { name: "United States", code: "US" },
      { name: "Vietnam", code: "VN" },
      { name: "Yemen", code: "YE" },
    ];

    // ✅ Keep only available countries
    const filteredCountries = countryData
      .filter(country =>
        availableCountrySet.has(country.name.toLowerCase())
      )
      .sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      );
    console.log("Filtered Countries:", filteredCountries);
    return filteredCountries;
  } catch (error) {
    console.error("Error in fetching country", error.message);
    return [];
  }
};

export const FetchStateListdata = async (code) => {
  try {


    const stateData = await axios.get(`https://api.countrystatecity.in/v1/countries/${code}/states`, {
      headers: {
        "X-CSCAPI-KEY": "ZXNReFJzUk5kcDJreUJiMU0xeUxRdDZzNWNGS2VlWWYwVGJFQkU2cQ==",
      },
    })
    const stateList = stateData.data.map(state => ({
      name: state.name,
      code: state.iso2,
    }))

    const List = stateList.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });

    return List;

  } catch (error) {
    console.log("error", error.message)
  }

};



export const FetchCityListdata = async (countryCode, stateCode) => {
  if (countryCode && stateCode) {
    const cityData = await axios.get(`https://api.countrystatecity.in/v1/countries/${countryCode}/states/${stateCode}/cities`, {
      headers: {
        "X-CSCAPI-KEY": "ZXNReFJzUk5kcDJreUJiMU0xeUxRdDZzNWNGS2VlWWYwVGJFQkU2cQ==",
      },
    })
    const List = cityData.data.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
    });
    return List
  }
};







const departmento = [{name:"Amazonas", code :"AMZ"}]
const provincia=[{name:"Chachapoyas", code:"CPY", depCode:"AMZ"}]
const Distrito=[{name:"Chachapoyas", code:"CPY", proCode:"CPY", depCode:"AMZ"}]
